module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAXCAYAAAD+4+QTAAAACXBIWXMAAAsSAAALEgHS3X78AAABOUlEQVRIidWWwXGDMBBFHx50Nh3EFWQpwVEDTjpwB3ELqSCkAlMCaUDjElAHpAN81oEcEBmsiRnLxpnJv6xWLPsQSH9Iuq5DiV4BOyBnPtVA4axpkvTxaeUnljMCBh2BfEG/gnsA8H13Kaev6A04zNA8B96HcRpcPDhrboYo0Sf54taGl+h/QJTorRJdK9HZXSBKdA7sAQHKqyBKdKFEbydKsjPjyyBKdAG8Anv/xFdraiXjxpkH50p0EwuN/SYH4IHIAxsLWQbxLpBQDb0JQm+y0ZDSRztqcBxHZ00DrIEPZ80uGuKsKYEXYO2saf30GvjycairpwAAoUGGoCrIa2A1dc9v+hPvSoF2lBdKdHuuOEInpz+l3/Mbn8sMgFBV4n8kqhFoTn06a56TruuAH0c9a3JXqPUbhW9DHlojxXu73gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/manager/usage_report_icon.png
// module id = oOxQ
// module chunks = 0